import React from "react";
import { graphql, compose } from "react-apollo";
import { connect } from "react-redux";
import { validate as buildValidations, validators } from "validate-redux-form";
import { notEmpty } from "../utils/validation";
import PropTypes from "prop-types";
import { Flex, Box } from "grid-styled";
import { InputContainer, Select } from "./forms";
import changeStatusMutation from "../mutations/ChangeStatus";
import Button from "./Button";
import { reduxForm, Field, formValueSelector } from "redux-form";
import setInitialValues from "../hocs/setInitialValues";
import { STRUCTURE_TYPES, STATUSES, HOLD_TYPES } from "../constants";

const STRUCTURE_TYPE_OPTIONS = STRUCTURE_TYPES.map(type => ({
  value: type,
  label: type
}));

const validate = values => {
  let errors = buildValidations(values, {
    status: notEmpty()("Please provide a status.")
  });

  if (values.status === "on_hold") {
    errors = {
      ...errors,
      ...buildValidations(values, {
        holdType: notEmpty()("Please provide a hold type.")
      })
    };
  }

  if (values.status === "in_production") {
    errors = {
      ...errors,
      ...buildValidations(values, {
        postedTurnaround: validators.regex(/\d+/)(
          "Please enter the number of days."
        )
      })
    };
  }

  return errors;
};

class ChangeStatusForm extends React.Component {
  static propTypes = {
    service: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      serviceType: PropTypes.string
    }),
    cancel: PropTypes.func,
    onSubmit: PropTypes.func.isRequired
  };

  static defaultProps = {
    onSubmit: () => true
  };

  availableStatuses = () => {
    return STATUSES[this.props.service.serviceType].filter(
      status => status.value !== "cancelled"
    );
  };

  onSubmit = values => {
    return this.props
      .changeStatus({
        ...values
      })
      .then(this.props.onSubmit);
  };

  renderOnHoldFields = () => {
    return [
      <Box key="holdType" pb={2}>
        <Field
          name="holdType"
          labelText="Hold Type"
          placeholder="Specify a hold type"
          component={InputContainer}
          fieldComponent={Select}
          options={HOLD_TYPES[this.props.service.serviceType]}
        />
      </Box>,
      <Box key="holdReason" pb={2}>
        <Field
          name="holdReason"
          labelText="Hold Reason"
          placeholder="e.g., Transmittal is missing necessary info"
          component={InputContainer}
        />
      </Box>
    ];
  };

  renderInProductionFields = () => {
    return [
      <Box key="postedTurnaround" pb={2}>
        <Field
          name="postedTurnaround"
          labelText="Posted Turnaround"
          placeholder="e.g., 7"
          component={InputContainer}
        />
      </Box>,
      <Box key="structureType" pb={2}>
        <Field
          name="structureType"
          labelText="Structure Type"
          placeholder="Select a structure type"
          component={InputContainer}
          fieldComponent={Select}
          options={STRUCTURE_TYPE_OPTIONS}
        />
      </Box>
    ];
  };

  render() {
    const { status, pristine, invalid, cancel } = this.props;
    return (
      <form onSubmit={this.props.handleSubmit(this.onSubmit)}>
        <Box pb={2}>
          <Field
            name="status"
            labelText="Status"
            component={InputContainer}
            fieldComponent={Select}
            options={this.availableStatuses()}
          />
        </Box>
        {status === "on_hold" && this.renderOnHoldFields()}
        {status === "in_production" && this.renderInProductionFields()}
        <Flex justify="flex-end">
          {cancel && (
            <Button type="button" onClick={cancel}>
              Cancel
            </Button>
          )}
          <Button
            type="submit"
            style={{ marginLeft: 4 }}
            variant="primary"
            disabled={pristine || invalid}
          >
            Change Status
          </Button>
        </Flex>
      </form>
    );
  }
}

const formName = "changeStatus";
const selector = formValueSelector(formName);

const enhance = compose(
  graphql(changeStatusMutation, {
    props({ ownProps: { service }, mutate }) {
      return {
        changeStatus({
          status,
          holdType,
          holdReason,
          postedTurnaround,
          structureType,
          certifiedReview
        }) {
          return mutate({
            variables: {
              id: service.id,
              input: {
                status,
                holdType,
                holdReason,
                postedTurnaround,
                structureType,
                certifiedReview
              }
            }
          });
        }
      };
    }
  }),
  connect(state => ({
    status: selector(state, "status")
  })),
  setInitialValues(props => {
    const { service } = props;
    return {
      status: service.status || "",
      holdType: service.holdType || "",
      holdReason: service.holdReason || "",
      postedTurnaround: service.postedTurnaround
        ? `${service.postedTurnaround}`
        : "",
      structureType: service.structureType || "",
      certifiedReview: !!service.certifiedReview
    };
  }),
  reduxForm({
    form: formName,
    validate
  })
);

export default enhance(ChangeStatusForm);



// WEBPACK FOOTER //
// ./src/components/ChangeStatusForm.js